// import Glide, { Controls, Keyboard, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
// import device from '../helpers/device'
import refs from '../helpers/refs'

class CProductHero {
  constructor (el) {
    this.$el = el
    this.$refs = refs(this.$el)

    this.init()
  }

  init () {
    // If there's only a single element, the ref is an object instead of an array
    if (!Array.isArray(this.$refs.imageOuter)) {
      this.$refs.imageOuter = [this.$refs.imageOuter]
    }

    // Init product image slider
    // if (this.$refs.glide) {
    //   new Glide(this.$refs.glide, {
    //     type: 'slider'
    //   }).mount({ Controls, Keyboard, Breakpoints, Swipe })
    // }

    // ZOOM - per slide
    // if (device.isDesktop()) {
    //   this.$refs.imageOuter.forEach(($imageOuter) => {
    //     $imageOuter.addEventListener('mousemove', (e) => {
    //       const hdImage = $imageOuter.querySelector('.hd-image')
    //       // Get the dimensions of the image
    //       const imageWidth = hdImage.offsetWidth
    //       const imageHeight = hdImage.offsetHeight
    //       // Get the dimensions of the parent
    //       const parentWidth = $imageOuter.offsetWidth
    //       const parentHeight = $imageOuter.offsetHeight
    //       // show the image
    //       hdImage.classList.remove('hidden')
    //       // calculate the cursor position relative to the parent element
    //       const xRatio = e.offsetX / parentWidth
    //       const yRatio = e.offsetY / parentHeight
    //       // use the calculated ratios to get the position on the HD image
    //       const hdOffsetX = (imageWidth - parentWidth) * xRatio
    //       const hdOffsetY = (imageHeight - parentHeight) * yRatio
    //       // move the image
    //       hdImage.style.transform = `translate(${-hdOffsetX}px, ${-hdOffsetY}px), scale(2)`

    //       // hide the image if the mouse leaves the image
    //       if (e.offsetX < 0 || e.offsetX > hdImage.offsetWidth || e.offsetY < 0 || e.offsetY > hdImage.offsetHeight) {
    //         hdImage.classList.add('hidden')
    //       }
    //     })

    //     $imageOuter.addEventListener('mouseleave', (e) => {
    //       const hdImage = $imageOuter.querySelector('.hd-image')
    //       hdImage.classList.add('hidden')
    //     })
    //   })
    // }
  }
}

// Wait for images to load in
window.addEventListener('load', () => {
  document
    .querySelectorAll('[data-c-product-hero]')
    .forEach(el => new CProductHero(el))
})
